import { FilterMatchMode } from 'primereact/api';
import { Checkbox } from 'primereact/checkbox';

export class RolArchivo {
    constructor(asignarRef, permss) {
        const renderCheckbox = (rowData, campoDb, opcion) => {
            const isProcessing = rowData[`loading_${campoDb}`] === true;

            return (
                <div className="flex justify-content-center align-items-center" style={{ height: '2rem' }}>
                    {isProcessing ? (
                        <i className="pi pi-spin pi-spinner" style={{ fontSize: '1.5rem', color: 'var(--primary-color)' }}></i>
                    ) : (
                        <Checkbox onChange={e => { if (asignarRef.current) asignarRef.current(e, rowData, opcion, campoDb); }} checked={rowData[campoDb] === true} disabled={!permss?.actualizar} />
                    )}
                </div>
            );
        };

        this.model = {
            nombre: {
                header: 'Roles disponibles',
                table: true,
                sort: true,
                filter: true,
                matchMode: FilterMatchMode.CONTAINS,
                filterPlaceholder: 'Filtrar por nombre',
                style: { width: '30%' },
            },
            fecha: {
                header: 'Fecha Asignación',
                table: true,
                sort: true,
                filter: false,
                isDate: true,
                style: { width: '15%' }
            },
            consultar: {
                header: 'Consultar',
                table: true,
                isBoolean: true,
                filter: true,
                body: (rowData) => renderCheckbox(rowData, 'consultar', 0)
            },
            crear: {
                header: 'Crear',
                table: true,
                isBoolean: true,
                filter: true,
                body: (rowData) => renderCheckbox(rowData, 'crear', 1)
            },
            actualizar: {
                header: 'Editar',
                table: true,
                isBoolean: true,
                filter: true,
                body: (rowData) => renderCheckbox(rowData, 'actualizar', 2)
            },
            eliminar: {
                header: 'Eliminar',
                table: true,
                isBoolean: true,
                filter: true,
                body: (rowData) => renderCheckbox(rowData, 'eliminar', 3)
            }
        };
    }
}